import { render } from "./laborPracticeMuseum.vue?vue&type=template&id=82ea9702&scoped=true"
import script from "./laborPracticeMuseum.vue?vue&type=script&lang=js"
export * from "./laborPracticeMuseum.vue?vue&type=script&lang=js"

import "./laborPracticeMuseum.vue?vue&type=style&index=0&id=82ea9702&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82ea9702"]])

export default __exports__